<template>
  <div class="home-footer">
    ©copyright    华侨大学建筑学院虚拟仿真实验申报管理平台
  </div>
</template>

<script>
export default {
  name: "home-footer",
  components: {},
  props: [],
  data() {
    return {};
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.home-footer {
  width: 100%;
  height: 53px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #6A727C;
  line-height: 18px;
}
</style>